import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasConsented } from './utils/consent';

export const GA_MEASUREMENT_ID = 'G-NCM0MQM9BN';
const POSTHOG_KEY = 'phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE';

let gaInitialised = false;
let posthogInitialised = false;

// Initialise GA4 — only call when user has consented
export const initGA = () => {
  if (typeof window === 'undefined' || gaInitialised) return;
  if (!hasConsented()) return;

  // Set default consent to granted (user accepted)
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('consent', 'default', { analytics_storage: 'granted' });

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  gaInitialised = true;
};

// Initialise PostHog — only call when user has consented
export const initPostHog = () => {
  if (typeof window === 'undefined' || posthogInitialised) return;
  if (!hasConsented()) return;

  const script = document.createElement('script');
  script.textContent = `
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('${POSTHOG_KEY}',{api_host:'https://us.i.posthog.com',person_profiles:'identified_only'});
  `;
  document.head.appendChild(script);
  posthogInitialised = true;
};

// Initialise all analytics — only when consented
export const initAllAnalytics = () => {
  if (!hasConsented()) return;
  initGA();
  initPostHog();
};

// Track page views
export const trackPageView = (url) => {
  if (!hasConsented() || typeof window.gtag === 'undefined') return;
  window.gtag('config', GA_MEASUREMENT_ID, { page_path: url });
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (!hasConsented() || typeof window.gtag === 'undefined') return;
  window.gtag('event', eventName, eventParams);
};

// Hook to track page views on route changes
export const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
};

// Predefined event trackers
export const trackVideoView = (videoId, videoTitle) => {
  trackEvent('video_view', { video_id: videoId, video_title: videoTitle });
};

export const trackDownload = (fileName, fileType) => {
  trackEvent('file_download', { file_name: fileName, file_type: fileType });
};

export const trackCalculatorClick = (source) => {
  trackEvent('calculator_click', { source });
};
